export default __webpack_public_path__ + "static/media/ic-turbo.22bba495.svg";